import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CheckboxEvent } from '@shared/abstraction/checkbox/checkbox-event';
import { SecurityStatus } from '@shared/enums/security-status';
import { SecurityCardTaxResultItem } from '../../models/security-card-tax-results-item';

export interface TaxResult {
  status: 'Approved' | 'Pending approval';
  title: string;
  needsAttention: boolean;
  dividends: number;
  capitalGains: number;
  approvedBy: string;
}
@Component({
  standalone: false,
  selector: 'gstar-tax-card',
  templateUrl: './tax-card.component.html',
  styleUrls: ['./tax-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxCardComponent {
  @Input() security!: SecurityCardTaxResultItem;
  @Output() selection = new EventEmitter<SecurityCardTaxResultItem>();

  securityStatusItems = SecurityStatus;

  onSelectionChange(
    row: SecurityCardTaxResultItem,
    event: CheckboxEvent
  ): void {
    row.isChecked = event.checkboxState;
    this.selection.emit(row);
  }
}
